import { ref, type VNode } from 'vue'

type Placement = 'top' | 'right' | 'bottom' | 'left'

const shouldTooltipShow = ref(false)
const tooltipContent = ref<string | VNode | null>(null)
const tooltipTrigger = ref<HTMLElement | null>(null)
const tooltipPlacement = ref<Placement>('top')

type ShowTooltipOptions = {
	trigger: HTMLElement
	content?: string | VNode | null
	placement?: Placement
}

export const useOneTooltip = () => {
	return {
		shouldTooltipShow,
		tooltipContent,
		tooltipTrigger,
		tooltipPlacement,
		showTooltip: (opts: ShowTooltipOptions) => {
			const content = opts.content ?? null
			if (content === null || (typeof content === 'string' && !content.trim())) {
				shouldTooltipShow.value = false
				return
			}
			tooltipTrigger.value = opts.trigger
			tooltipContent.value = content
			tooltipPlacement.value = opts.placement || 'top'
			shouldTooltipShow.value = true
		},
		hideTooltip: () => {
			shouldTooltipShow.value = false
		},
	}
}

export const oneTooltipInstanceExists = ref(false)
